import {useEffect, useState} from "react";
import axios from "axios";
import styles from "./RelatedTours.module.scss";
import CardCarousel from "../../pages/Top/TopRecommendedTours/CardCarousel";

const RelatedTours = ({tourId}) => {
    const [relatedTours, setRelatedTours] = useState([]);
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        if (!tourId) return;

        loadRecommendations();
    }, [tourId]);

    const loadRecommendations = async () => {
        try {
            const res = await axios.get(
                `${apiUrl}/api/tours/${tourId}/recommendations`
            );

            setRelatedTours(res.data.data || []);
        } catch (error) {
            console.error(
                "Failed to load recommendations",
                error
            );
        }
    };

    if (!relatedTours.length) {
        return null;
    }

    return (
        <div className={"row mt-5"}>
            <div className={'col-12 mb-3'}>
                <h3 className={styles.title}>
                    このツアーもおすすめ
                </h3>
            </div>
            <div className={'col-12'}>
                <CardCarousel tours={relatedTours}/>
            </div>
        </div>
    );
};

export default RelatedTours;